import { render, staticRenderFns } from "./RelativePlaylist.vue?vue&type=template&id=fa167d48"
import script from "./RelativePlaylist.vue?vue&type=script&lang=js"
export * from "./RelativePlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports